import SsoRoutes from './sso/SsoRoutes';

export default [...SsoRoutes];
